<template>
	<div class="main">
		<div class="g-mnc g-mnc-kefu">
			<div class="sidebar">
				<div class="service-content">
					<div class="u-sideBar-title">员工</div>
					<!--  <div>
                   <el-menu :default-active="$route.path"    class="el-menu-vertical-demo"  @open="handleOpen" @close="handleClose" router>
                     <template v-for="(item,index) in nav_list">
                       &lt;!&ndash;无子菜单&ndash;&gt;
                       <el-menu-item  :index="item.route">
                         <i :class="item.class"></i>
                         <span slot="title">{{item.message}}</span>
                       </el-menu-item>
                     </template>
                   </el-menu>
					</div>-->
					<ul class="tabs">
						<li
							:class="item.class"
							@click="cutover(index,item)"
							v-for="(item,index,) in menus"
						>{{item.message}}</li>
					</ul>
				</div>
			</div>
			<div class="content">
				<div :is="movement" @id="revice" :shu="shu" ></div>
			</div>
		</div>
	</div>
</template>

<script>
import manage from '@/components/manage/staff/manage'
import edit from '@/components/manage/staff/edit'
export default {
	name: 'staff',
	props: [],
	data() {
		return {
			movement: 'manage',
			shu:0,
			menus: [
				{
					class: 'current',
					message: '员工管理'
				}
			]
		}
	},
	watch: {},
	mounted: function() {
		
		console.log(this.$route.query) //接收传过来的参数
		//this.movement=this.$route.query.id
		if (this.$route.query.length > 0) {
			this.movement = this.$route.query.id
		}
	},
	methods: {
		handleOpen(key, keyPath) {
			console.log(key, keyPath)
		},
		handleClose(key, keyPath) {
			console.log(key, keyPath)
		},
		revice(id,edit) {
			console.log('我是传过来的' + id)
			this.shu=edit;
			this.movement = id
		}
	},
	components: {
		manage,
		edit
	}
}
</script>

<style scoped>
.main {
	flex: 1;
	display: flex;
	flex-direction: column;
	height: 100%;
	position: relative;
	background-color: #fff;
}
.g-mnc {
	display: flex;
	flex: 1;
	flex-direction: row;
	padding: 40px;
	box-sizing: border-box;
}
.g-mnc-kefu {
	position: relative;
	-moz-border-radius: 2px;
	border-radius: 2px;
	box-sizing: border-box;
	flex-direction: column;
	height: calc(40%);
	padding: 0 0 0 0px;
	display: flex;
	flex-direction: row;
}

.g-mnc-kefu .sidebar {
	height: 100%;
}
.service-content {
	width: 210px;
	transition: width 0.2s;
	background: #f7f8fa;
	overflow-x: hidden;
	overflow-y: auto;
	height: 100%;
}
.g-mnc-kefu .content {
	height: 100%;
	overflow: auto;
	display: flex;
	flex-direction: column;
	position: relative;
	padding: 0 30px;
	padding-top: 10px;
	width: 100%;
	box-sizing: border-box;
}
.u-sideBar-title {
	display: flex;
	align-items: center;
	justify-content: space-between;
	font-size: 18px;
	color: #222;
	padding: 20px;
	overflow: hidden;
	white-space: nowrap;
	text-overflow: ellipsis;
}

.tabs li {
	background-color: #f7f8fa;
	line-height: 50px;
	padding-left: 20px;
}
.tabs li.current {
	background-color: #edeef0;
	color: #337eff;
	border-right: 3px solid #337eff;
}
/*子菜单*/
.el-menu {
	background-color: #f7f8fa;
}
.is-active {
	background-color: #edeef0;
	border-right: 3px solid #337eff;
}
</style>



// WEBPACK FOOTER //
// src/components/manage/staff/staff.vue